export default __webpack_public_path__ + "static/media/doctors_banner.cfe5be78.png";